module.exports = {
  translations: {
    
  }
}